import { Shift } from 'models'
import api from './api'

export const fetchShifts = async (id: number): Promise<Shift[]> => {
    const resp = await api.get(`/locations/${id}/shifts`)

    return resp.data
}
